import React, { FC, useState, useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import { CHECK_CONNECTION } from "./graphql/account/query";
import { CheckConnection } from "./graphql/account/types/CheckConnection";
import NoConnection from "./components/CheckConnection/NoConnection";
import { Navigate, Route, Routes as RoutesDom } from "react-router-dom";
import Liveness from "./components/Liveness/Liveness";
import SignupInProgression from "./components/Common/SignupProgression/SignupProgression";
import CompanyInfo from "./components/StepCompanyInfo/CompanyInfo/CompanyInfoProvider";
import GetId from "./components/GetId/GetIdProvider";
import CreateAccount from "./components/StepCreateAccount";
import SelectOffer from "./components/StepSelectOffer";
import CompanySearch from "./components/StepCompanyInfo/CompanySearch/CompanySearchProvider";
import Leader from "./components/StepLeader/LeaderProvider";
import Ubo from "./components/StepUbo/AddPercentProvider";
import SignedContract from "./components/StepContract/SignedContractProvider";
import Choise from "./components/StepChoise/ChoiseProvider";
import Explanation from "./components/StepExplanation/ExplanationProvider";
import LegalPlace from "./components/StepLegalPlace/LegalPlaceProvider";
import FinishLegalPlace from "./components/StepLegalPlace/FinishLegalPlace";

const Routes: FC = () => {
  const CONNEXION_MAX = 5;
  const [countConn, setCountConn] = useState(0);
  const [getCon, { error }] = useLazyQuery<CheckConnection>(CHECK_CONNECTION, {
    onError: (error) => {
      setCountConn(countConn + 1);
    },
  });
  useEffect(() => {
    if (countConn == 0) {
      getCon();
    } else if (countConn < CONNEXION_MAX) {
      setTimeout(function () {
        getCon();
      }, 2000);
    }
  }, [countConn]);
  if (error && countConn === CONNEXION_MAX) {
    const { networkError } = error;
    if (networkError && networkError.message) {
      return <NoConnection />;
    }
  }

  return (
    <RoutesDom>
      <Route path="/" element={<CreateAccount />} />
      <Route path="/liveness" element={<Liveness />} />
      <Route path="/step" element={<SignupInProgression />} />
      <Route path="/choise" element={<Choise />} />
      <Route path="/offer" element={<SelectOffer />} />
      <Route path="/package" element={<SelectOffer create />} />
      <Route path="/explanation" element={<Explanation />} />
      <Route path="/legalplace" element={<LegalPlace />} />
      <Route path="/resume/:token" element={<FinishLegalPlace />} />
      <Route path="/manager" element={<Leader />} />
      <Route path="/company" element={<CompanySearch />} />
      <Route path="/company/:incorporationCode" element={<CompanySearch />} />
      <Route path="/companyInfo/:incorporationCode" element={<CompanyInfo />} />
      <Route path="/companyInfo/create" element={<CompanyInfo />} />
      <Route path="/shareholdersPercent" element={<Ubo />} />
      <Route path="/identity-verification" element={<GetId />} />
      <Route path="/contrat" element={<SignedContract />} />
      <Route element={<Navigate to="/" />} />
    </RoutesDom>
  );
};

export default Routes;
